import { 
    TERME_ASYMETRIQUE_DESACTIVANT_first_import_payoffInfo, 
    TERME_ASYMETRIQUE_DESACTIVANT_second_import_payoffInfo, 
    TERME_ASYMETRIQUE_DESACTIVANT_third_import_payoffInfo, 
    TERME_ASYMETRIQUE_DESACTIVANT_first_export_payoffInfo, 
    TERME_ASYMETRIQUE_DESACTIVANT_second_export_payoffInfo, 
    TERME_ASYMETRIQUE_DESACTIVANT_third_export_payoffInfo
} from "src/shared/Cotation/describe/TermeAsymetriqueDesactivant"
import { checkExistValuesForm } from "src/shared/utils/helpers"
import { TERME_ASYMETRIQUE_DESACTIVANT_default } from "./default/TermeAsymetriqueDesactivant"
import { axisConfig } from "./config/AxisConfig"
import { CHART_STYLES } from "./config/ChartStyles"
import { ProdcutType } from "src/type/product"

const styles = CHART_STYLES[ProdcutType.TERME_ASYMETRIQUE_DESACTIVANT]

const defaultConfig = axisConfig("Cours à l'échéance", "Cours de couverture") 

const TERME_ASYMETRIQUE_DESACTIVANT_first_import_chart = form => ([
    {
        type: "line",
        key: "ko-to-qqc",
        data: [
            {x: form.ko*0.9, y:form.ko*0.9}, 
            {x: form.ko, y: form.ko}
        ],
        color: styles.ko_line.color,
        strokeWidth: 3,
    }, {
        type: "line",
        key: "ko-line",
        data: [
            {x: form.ko , y:form.ko }, 
            {x: form.ko, y: form.strike}
        ],
        color: styles.ko_line.color,
        strokeDasharray: [7, 4],
        strokeWidth: 0.5
    },
    {
        type: "line",
        key: "montant_min_1",
        data: [
            {x: form.ko , y:form.strike}, 
            {x: form.strike, y: form.strike}
        ],
        color: styles.montant_min.color,
        strokeWidth: styles.montant_min.strokeWidth,
    },
    {
        type: "line",
        key: "montant_max_1",
        data: [
            {x: form.strike , y:form.strike}, 
            {x: form.strike*1.05, y: form.strike}
        ],
        color: styles.montant_max.color,
        strokeWidth: styles.montant_max.strokeWidth,
    },
    {
        type: "line",
        key: "cours-a-terme",
        data: [
            {x: form.ko*0.9 , y:form.ko*1.025},
            {x: form.strike*1.05, y: form.ko*1.025}
        ],
        color: styles.cours_a_terme.color,
        strokeDasharray: styles.cours_a_terme.strokeDasharray,
        strokeWidth: styles.cours_a_terme.strokeWidth,
    },
    {
        type: "line",
        key: "support-1",
        data: [
            {x: form.strike , y:form.strike*1.1}, 
            {x: form.strike*1.05, y: form.strike*1.1}
        ],
        color: styles.montant_max.color,
        strokeWidth: 0
    },
    {
        type: "point",
        key: "strike-1",
        data: [
            {x: form.strike , y: form.ko * 0.9}
        ],
        color: styles.strike.color,
        caption: `Strike : ${form.strike}`
    },
    {
        type: "point",
        key: "strike-2",
        data: [
            {x: form.ko * 0.9 , y: form.strike}
        ],
        color: styles.strike.color,
        caption: `Strike : ${form.strike}`
    },
    {
        type: "point",
        key: "ko-point",
        data: [
            {x: form.ko , y: form.ko* 0.9}
        ],
        color: styles.montant_max.color,
        caption: `ko : ${form.ko}`
    }
])
const TERME_ASYMETRIQUE_DESACTIVANT_second_import_chart = form => ([
    {
        type: "line",
        key: "ko-line",
        data: [
            {x: form.ko , y:form.ko * 0.95}, 
            {x: form.ko, y: form.strike}
        ],
        color: styles.ko_line.color,
        strokeDasharray: [7, 4],
        strokeWidth: 0.5
    },
    {
        type: "line",
        key: "montant_min_1",
        data: [
            {x: form.ko , y:form.strike}, 
            {x: form.strike, y: form.strike}
        ],
        color: styles.montant_min.color,
        strokeWidth: styles.montant_min.strokeWidth,
    },
    {
        type: "line",
        key: "montant_max_1",
        data: [
            {x: form.strike, y: form.strike}, 
            {x: form.strike * 1.05 , y: form.strike }
        ],
        color: styles.montant_max.color,
        strokeWidth: styles.montant_max.strokeWidth,
    },
    {
        type: "line",
        key: "support-1",
        data: [
            {x: form.strike , y:form.strike*1.1}, 
            {x: form.strike*1.05, y: form.strike*1.1}
        ],
        color: styles.montant_max.color,
        strokeWidth: styles.montant_max.strokeWidth,
    },
    {
        type: "line",
        key: "cours-a-terme",
        data: [
            {x: form.ko * 0.95 , y:form.strike*0.95},
            {x: form.strike*1.05, y: form.strike*0.95}
        ],
        color: styles.cours_a_terme.color,
        strokeDasharray: styles.cours_a_terme.strokeDasharray,
        strokeWidth: styles.cours_a_terme.strokeWidth,
    },
    {
        type: "point",
        key: "ko-point",
        data: [
            {x: form.ko , y: form.ko* 0.95}
        ],
        color: styles.montant_max.color,
        caption: `ko : ${form.ko}`
    },
    {
        type: "point",
        key: "strike-1",
        data: [
            {x: form.strike , y: form.ko * 0.95}
        ],
        color: styles.strike.color,
        caption: `Strike : ${form.strike}`
    },
    {
        type: "point",
        key: "strike-2",
        data: [
            {x: form.ko * 0.95, y: form.strike}
        ],
        color: styles.strike.color,
        caption: `Strike : ${form.strike}`
        
    }
])
const TERME_ASYMETRIQUE_DESACTIVANT_third_import_chart = form => ([
    {
        type: "line",
        key: "ko",
        data: [
            {x: 0 , y:0}, 
            {x:1, y: 1}
        ],
        color: styles.ko_line.color,
        strokeWidth: 3
    },
])
const TERME_ASYMETRIQUE_DESACTIVANT_first_export_chart = form => ([
    {
        type: "line",
        key: "montant_max_1",
        data: [
            {x: form.strike * 0.95 , y:form.strike}, 
            {x: form.strike , y: form.strike}
        ],
        color: styles.montant_max.color,
        strokeWidth: 12
    },
    {
        type: "line",
        key: "montant_min_1",
        data: [
            {x: form.strike , y:form.strike}, 
            {x: form.ko, y: form.strike}
        ],
        color: styles.montant_min.color,
        strokeWidth: 3,
    },
    {
        type: "line",
        key: "ko-line",
        data: [
            {x: form.ko , y:form.strike}, 
            {x: form.ko, y: form.ko}
        ],
        color: styles.ko_line.color,
        strokeDasharray: [7, 4],
        strokeWidth: 0.5
    },
    {
        type: "line",
        key: "ko-to-aac",
        data: [
            {x: form.ko , y:form.ko}, 
            {x: form.ko * 1.05, y: form.ko * 1.05}
        ],
        color: styles.ko_line.color,
        strokeWidth: 3
    },
    {
        type: "line",
        key: "cours-a-terme",
        data: [
            {x: form.strike * 0.95 , y:form.ko*0.975},
            {x: form.ko * 1.05, y: form.ko*0.975}
        ],
        color: styles.cours_a_terme.color,
        strokeDasharray: [5, 5],
        strokeWidth: 0.5
    },
    {
        type: "point",
        key: "ko-point",
        data: [
            {x: form.ko , y: form.strike * 0.9}
        ],
        color: styles.montant_max.color,
        caption: `ko : ${form.ko}`
    },
    {
        type: "point",
        key: "strike-1",
        data: [
            {x: form.strike , y: form.strike * 0.9}
        ],
        color: styles.strike.color,
        caption: `Strike : ${form.strike}`
        
    },
    {
        type: "point",
        key: "strike-2",
        data: [
            {x: form.strike * 0.95, y: form.strike}
        ],
        color: styles.strike.color,
        caption: `Strike : ${form.strike}`
    }
])
const TERME_ASYMETRIQUE_DESACTIVANT_second_export_chart = form => ([
    {
        type: "line",
        key: "montant_max_1",
        data: [
            {x: form.strike * 0.95 , y:form.strike}, 
            {x: form.strike , y: form.strike}
        ],
        color: styles.montant_max.color,
        strokeWidth: 12
    },
    {
        type: "line",
        key: "montant_min_1",
        data: [
            {x: form.strike , y:form.strike}, 
            {x: form.ko, y: form.strike}
        ],
        color: styles.montant_min.color,
        strokeWidth: 3,
    },
    {
        type: "line",
        key: "ko-line",
        data: [
            {x: form.ko , y:form.strike * 0.90 }, 
            {x: form.ko, y: form.strike}
        ],
        color: styles.ko_line.color,
        strokeDasharray: [7, 4],
        strokeWidth: 0.5
    },
    {
        type: "line",
        key: "support-1",
        data: [
            {x: form.strike , y:form.strike*1.1}, 
            {x: form.strike*1.05, y: form.strike*1.1}
        ],
        color: styles.montant_max.color,
        strokeWidth: 0
    },
    {
        type: "line",
        key: "cours-a-terme",
        data: [
            {x: form.ko , y:form.strike*1.05},
            {x: form.strike * 0.95, y: form.strike*1.05}
        ],
        color: styles.cours_a_terme.color,
        strokeDasharray: [5, 5],
        strokeWidth: 0.5
    },
    {
        type: "point",
        key: "strike-1",
        data: [
            {x: form.strike , y: form.strike * 0.9}
        ],
        color: styles.strike.color,
        caption: `Strike : ${form.strike}`
    },
    {
        type: "point",
        key: "strike-2",
        data: [
            {x: form.strike * 0.95, y: form.strike}
        ],
        color: styles.strike.color,
        caption: `Strike : ${form.strike}`
    }, 
    {
        type: "point",
        key: "ko-point",
        data: [
            {x: form.ko , y: form.strike * 0.9}
        ],
        color: styles.montant_max.color,
        caption: `ko : ${form.ko}`
    }
])
const TERME_ASYMETRIQUE_DESACTIVANT_third_export_chart = form => ([
    {
        type: "line",
        key: "ko",
        data: [
            {x: 0 , y:0}, 
            {x:1, y: 1}
        ],
        color: styles.ko_line.color,
        strokeWidth: 3
    },
])


export const TERME_ASYMETRIQUE_DESACTIVANT_data = (form) => ([
    {
        option: "1",
        label: 'Profil à l’échéance (si import et barrière européenne)',
        chart: TERME_ASYMETRIQUE_DESACTIVANT_first_import_chart(form),
        chartDefault: TERME_ASYMETRIQUE_DESACTIVANT_first_import_chart(TERME_ASYMETRIQUE_DESACTIVANT_default[0]),
        describe:TERME_ASYMETRIQUE_DESACTIVANT_first_import_payoffInfo(form),
        legends: {
            lines: [
                {title: "Montant max",      color: styles.montant_max.color,    strokeWidth: styles.montant_max.strokeWidth},
                {title: "Montant min",      color: styles.montant_min.color,    strokeWidth: styles.montant_min.strokeWidth}, 
                {title: "Cours à terme",    color: styles.cours_a_terme.color,  strokeWidth: styles.cours_a_terme.strokeWidth, strokeDasharray: styles.cours_a_terme.strokeDasharray},
            ],
            points: [
                {title: "Strike",           color: styles.strike.color},
                {title: "KO",               color: styles.montant_max.color},
            ]
        },
        config: defaultConfig,
        condition: checkExistValuesForm(form, ["strike", "ko"]),
        isAvailable: form.sens === "import" && form.style_de_barriere === "européenne"
    },
    {
        option: "2",
        label: `Profil à l’échéance (si import et barrière ${form.style_de_barriere} non touchée)`,
        chart: TERME_ASYMETRIQUE_DESACTIVANT_second_import_chart(form),
        chartDefault: TERME_ASYMETRIQUE_DESACTIVANT_second_import_chart(TERME_ASYMETRIQUE_DESACTIVANT_default[1]),
        describe: TERME_ASYMETRIQUE_DESACTIVANT_second_import_payoffInfo(form),
        legends: {
            lines: [
                {title: "Montant max",      color: styles.montant_max.color,    strokeWidth: styles.montant_max.strokeWidth},
                {title: "Montant min",      color: styles.montant_min.color,    strokeWidth: styles.montant_min.strokeWidth}, 
                {title: "Cours à terme",    color: styles.cours_a_terme.color,  strokeWidth: styles.cours_a_terme.strokeWidth, strokeDasharray: styles.cours_a_terme.strokeDasharray},
            ],
            points: [
                {title: "Strike",           color: styles.strike.color},
                {title: "KO",               color: styles.montant_max.color},
            ]
        },
        config: defaultConfig,
        condition: checkExistValuesForm(form, ["strike", "ko"]),
        isAvailable: form.sens === "import" && (form.style_de_barriere === "américaine" || form.style_de_barriere === "à fenêtre")
    },
    {
        option: "3",
        label: `Profil à l’échéance (si import et barrière ${form.style_de_barriere} touchée)`,
        chart: TERME_ASYMETRIQUE_DESACTIVANT_third_import_chart(form),
        chartDefault: TERME_ASYMETRIQUE_DESACTIVANT_third_import_chart(TERME_ASYMETRIQUE_DESACTIVANT_default[2]),
        describe: TERME_ASYMETRIQUE_DESACTIVANT_third_import_payoffInfo(form),
        legends: {
            lines: [
            ],
            points: [
            ]
        },
        config: defaultConfig,
        condition: checkExistValuesForm(form, ["strike", "ko"]),
        isAvailable: form.sens === "import" && (form.style_de_barriere === "américaine" || form.style_de_barriere === "à fenêtre")
    },
    {
        option: "4",
        label: 'Profil à l’échéance (si export et barrière européenne)',
        chart: TERME_ASYMETRIQUE_DESACTIVANT_first_export_chart(form),
        chartDefault: TERME_ASYMETRIQUE_DESACTIVANT_first_export_chart(TERME_ASYMETRIQUE_DESACTIVANT_default[3]),
        describe: TERME_ASYMETRIQUE_DESACTIVANT_first_export_payoffInfo(form),
        legends: {
            lines: [
                {title: "Montant max",      color: styles.montant_max.color,    strokeWidth: styles.montant_max.strokeWidth},
                {title: "Montant min",      color: styles.montant_min.color,    strokeWidth: styles.montant_min.strokeWidth}, 
                {title: "Cours à terme",    color: styles.cours_a_terme.color,  strokeWidth: styles.cours_a_terme.strokeWidth, strokeDasharray: styles.cours_a_terme.strokeDasharray},
            ],
            points: [
                {title: "Strike",           color: styles.strike.color},
                {title: "KO",               color: styles.montant_max.color},
            ]
        },
        config: defaultConfig,
        condition: checkExistValuesForm(form, ["strike", "ko"]),
        isAvailable: form.sens === "export" && form.style_de_barriere === "européenne"
    },
    {
        option: "5",
        label: `Profil à l’échéance (si export et barrière ${form.style_de_barriere} non touchée)`,
        chart: TERME_ASYMETRIQUE_DESACTIVANT_second_export_chart(form),
        chartDefault: TERME_ASYMETRIQUE_DESACTIVANT_second_export_chart(TERME_ASYMETRIQUE_DESACTIVANT_default[4]),
        describe: TERME_ASYMETRIQUE_DESACTIVANT_second_export_payoffInfo(form),
        legends: {
            lines: [
                {title: "Montant max",      color: styles.montant_max.color,    strokeWidth: styles.montant_max.strokeWidth},
                {title: "Montant min",      color: styles.montant_min.color,    strokeWidth: styles.montant_min.strokeWidth}, 
                {title: "Cours à terme",    color: styles.cours_a_terme.color,  strokeWidth: styles.cours_a_terme.strokeWidth, strokeDasharray: styles.cours_a_terme.strokeDasharray},
            ],
            points: [
                {title: "Strike",           color: styles.strike.color},
                {title: "KO",               color: styles.montant_max.color},
            ]
        },
        config: defaultConfig,
        condition: checkExistValuesForm(form, ["strike", "ko"]),
        isAvailable: form.sens === "export" && (form.style_de_barriere === "américaine" || form.style_de_barriere === "à fenêtre")
    },
    {
        option: "6",
        label: `Profil à l’échéance (si export et barrière ${form.style_de_barriere} touchée)`,
        chart: TERME_ASYMETRIQUE_DESACTIVANT_third_export_chart(form),
        chartDefault: TERME_ASYMETRIQUE_DESACTIVANT_third_export_chart(TERME_ASYMETRIQUE_DESACTIVANT_default[5]),
        describe: TERME_ASYMETRIQUE_DESACTIVANT_third_export_payoffInfo(form),
        legends: {
            lines: [
            ],
            points: [
            ]
        },
        config: defaultConfig,
        condition: checkExistValuesForm(form, ["strike", "ko"]),
        isAvailable: form.sens === "export" && (form.style_de_barriere === "américaine" || form.style_de_barriere === "à fenêtre")
    }
])


// WEBPACK FOOTER //
// ./src/shared/Cotation/chart/data/TermeAsymetriqueDesactivant.tsx